var _path, _rect, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 27V19.5C20 12.9 25.4 7.5 32 7.5C38.6 7.5 44 12.9 44 19.5V27",
    stroke: "#36F6FF",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6,
    y: 27,
    width: 38.8,
    height: 29.5,
    rx: 7,
    stroke: "#36F6FF",
    strokeWidth: 3.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 39,
    r: 4.2,
    fill: "#36F6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42.6V47.6",
    stroke: "#36F6FF",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleLockIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_lock_icon.e1103e4952a024d80f2a68a1a497a402.svg";
export { ForwardRef as ReactComponent };